import { Link } from "react-router-dom";
import { BrandMark } from "../components/BrandMark";

const privacySections = [
  ["What FitYouX processes", "Your account details, fit preferences, body measurements, scan quality metadata, garment orders and fit feedback. Front and side photographs are analysed in memory and are not written to your saved profile."],
  ["Why we process it", "To create and improve your personal garment fit, prepare reviewable manufacturing specifications, protect the service and support garment passports. We do not use body data for advertising or identity recognition."],
  ["Who can access it", "You and authorised production partners working on an order. Each brand receives only the customers and body profiles linked to its own products and orders."],
  ["Retention and control", "Your saved fit data remains available while your account is active. You can export it or permanently delete your account from Preferences. Operational backups are protected and expire through the backup cycle."],
  ["Contact", "Questions about privacy or data rights can be sent to privacy@fityoux.com."],
] as const;

const termsSections = [
  ["Pilot service", "FitYouX Vision v1 and its pattern engine are pilot tools. Body measurements require modelist review before an order can enter production."],
  ["Your responsibilities", "Use accurate height information, follow the guided capture instructions and do not upload photographs of another person without their permission."],
  ["Manufacturing", "A FitYouX specification is not an unattended production guarantee. Brand construction rules, fabric behaviour and modelist approval remain part of the final manufacturing decision."],
  ["Accounts", "Keep your password private and contact FitYouX if you believe your account has been accessed without permission."],
  ["Contact", "Questions about the service can be sent to support@fityoux.com."],
] as const;

export function LegalPage({ kind }: { kind: "privacy" | "terms" }) {
  const privacy = kind === "privacy";
  const sections = privacy ? privacySections : termsSections;
  return <main className="legal-page">
    <header><BrandMark /><Link to="/">Back to FitYouX</Link></header>
    <article>
      <span>Effective 26 August 2026</span>
      <h1>{privacy ? "Privacy, in plain language." : "FitYouX pilot terms."}</h1>
      <p>{privacy ? "This notice explains how FitYouX handles the information used to create a personal fit." : "These terms set clear expectations while FitYouX is being validated with brands and modelists."}</p>
      {sections.map(([title, copy]) => <section key={title}><h2>{title}</h2><p>{copy}</p></section>)}
    </article>
  </main>;
}
